import { FormField } from './FormField';

export const PhoneField = ({ name, title }) => {
  return (
    <FormField name={name} title={title} type="text" placeholder="06********" />
  );
};